<template>
  <div>
    <export-application v-if="applicationId && loggedUser.role != UserRoles.APPLICANT" :application-id="applicationId"></export-application>
    <component-loader
      :key="$i18n.locale"
      v-if="componentInitialized"
      :component-name="componentName"
      :default-component-name="defaultComponentName"
      id="applicationComponent"
    >
    </component-loader>
  </div>
</template>
<script>
  import {EventBus} from '@/event-bus.js';
  import {ApplicationService, UserRoles, GrantService, FileUploadService, GrantForm} from '@/services';
  import swal from 'sweetalert2';
  import {GrantWizard, GrantWizardTab, ExportApplication} from 'src/components';
  import ComponentLoader from './ComponentLoader';


  export default {
    components: {
      GrantWizard,
      GrantWizardTab,
      ComponentLoader,
      ExportApplication
    },
    data() {
      return {
        UserRoles,
        GrantForm,
        grantId: parseInt(this.$route.params.grantId),
        applicationId: parseInt(this.$route.params.applicationId) || null,

        componentInitialized: false,
        componentName: 'Dynamic',
        defaultComponentName: 'Default',
        data: {}
      }
    },
    async beforeCreate() {
      let loader = this.$loading.show();

      const grantId = parseInt(this.$route.params.grantId);
      const applicationId = parseInt(this.$route.params.applicationId) || 0;
      const loggedUser = this.$store.getters['Auth/loggedUser'];
      this.loggedUser = loggedUser;

      const objectAssignDeep = require('object-assign-deep');

      GrantForm.init();

      await GrantService.get(grantId).then((response) => {
        let componentName = response.data.componentName;

        switch (response.data.type) {
          case 'dynamic':
            break;

          case 'static':
            this.componentName = componentName;
            break;
        }

        let schema = JSON.parse(response.data.schema);

        GrantForm.model = _.cloneDeep(schema);
        GrantForm.files = _.cloneDeep(schema);

        this.componentInitialized = true;
      })

      if (!applicationId) {
        // creating new application
        GrantForm.initialized = true;
        GrantForm.isEditable = true;

        loader.hide();
        return;
      }

      // existing application
      await ApplicationService.getGrantApplication({
        grantId: grantId,
        applicationId: applicationId
      }).then((response) => {
        GrantForm.model = objectAssignDeep(GrantForm.model, response.data.model);
        GrantForm.files = {...GrantForm.files, ...response.data.files};

        GrantForm.regionId = response.data.regionId;
        GrantForm.title = response.data.title;
        GrantForm.status = response.data.status;
        GrantForm.reference = response.data.reference;
        GrantForm.isEditable = !response.data.locked && (loggedUser['id'] === response.data.userId && (!response.data.status || response.data.status === 'draft'));
        GrantForm.initialized = true;
      }).catch((error) => {
        // could be permission error
        alert(error.data.error);
        this.$router.push('/')
      })

      loader.hide();
    },
    mounted() {
      EventBus.$off('wizard-save-progress');
      EventBus.$off('wizard-complete-progress');

      EventBus.$off('grant-save-progress');
      EventBus.$on('grant-save-progress', data => {
        this.saveProgress();
      });

      EventBus.$off('grant-complete-progress');
      EventBus.$on('grant-complete-progress', data => {
        this.saveProgress('submitted');
      });

      EventBus.$off('wizard-next-step');
      EventBus.$on('wizard-next-step', data => {
      })
    },
    methods: {
      async saveProgress(status) {
        let data = GrantForm.model;
        let loader = this.$loading.show();
        let isSuccess = false;

        await ApplicationService.submitApplication({
          grantId: this.grantId,
          userId: this.$store.getters['Auth/loggedUser'].id,
          applicationId: this.applicationId,
          data: data,
          regionId: GrantForm.regionId,
          title: GrantForm.title,
          status: status
        }).then((response) => {
          this.applicationId = response.data.applicationId;
          isSuccess = true;

        }).catch((error) => {
          if (error.data.error === 'permission_error') {
            alert(error.data.error);
            this.$router.push('/ongoing-applications');
          } else {
            alert(error.data.error);
            this.$router.push('/');
          }
        });

        if (!isSuccess) {
          loader.hide();
          return;
        }

        await this.uploadFiles();

        loader.hide();

        if (status === 'submitted') {
          this.showNotification('complete-progress');
        } else {
          this.showNotification('save-progress');
        }

        if (status !== undefined && status === 'submitted') {
          this.$router.push('/ongoing-applications');
        }
      },

      submitApplication(data) {
        ApplicationService.submitApplication(data);
      },

      showNotification(type) {
        if (type === 'save-progress') {
          swal({
            title: this.$t('general.notification__success'),
            html: this.$t('general.notification__progress_saved').split("\n").join("<br>"),
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-primary btn-fill',
            type: 'success'
          });
        } else if (type === 'complete-progress') {
          swal({
            title: this.$t('general.notification__success'),
            html: this.$t('general.notification__application_submitted').split("\n").join("<br>"),
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-primary btn-fill',
            type: 'success'
          });
        }
      },

      async uploadFiles() {
        let files = GrantForm.files;
        let promises = [];

        for (var section in files) {
          if (GrantForm.files.hasOwnProperty(section)) {

            for (var subSection in files[section]) {
              if (files[section].hasOwnProperty(subSection)) {

                let fileToUpload = files[section][subSection];
                if (fileToUpload instanceof File) {

                  let formData = new FormData();
                  formData.append('file', fileToUpload);
                  formData.append('section', fileToUpload.section);
                  formData.append('$section', section);
                  formData.append('$subSection', subSection);
                  if (fileToUpload.id) {
                    formData.append('id', fileToUpload.id);
                  }

                  let promise = FileUploadService.uploadFile({
                    applicationId: this.applicationId,
                    formData: formData
                  }).then(function (response) {
                    let fdSection = formData.get('$section');
                    let fdSubSection = formData.get('$subSection');

                    files[fdSection][fdSubSection] = {
                      id: response.data.id,
                      name: response.data.filename,
                      download: response.data.download
                    };

                  }).catch(function (error) {
                    console.log('err', error);
                  })

                  promises.push(promise);
                }
              }
            }
          }
        }

        return await Promise.all(promises);
      }
    }
  };
</script>
<style lang="scss">
  .form-group {
    &.has-danger {
      .form-control {
        margin-bottom: 0;
      }
    }
  }
</style>